export const KAMELEOON_COOKIE_KEY = 'kameleoonVisitorCode';

export const createKameleoonCookieString = (visitorCode: string, key: string = KAMELEOON_COOKIE_KEY) => {
  let resultCookie = `${key}=${visitorCode}`;

  return resultCookie;
};

export const addKameleoonCookieToString = (existingCookie: string, visitorCode: string) => {
  const kameleoonCookie = createKameleoonCookieString(visitorCode);
  let result = existingCookie;
  result += result.length ? '; ' : '';
  result += kameleoonCookie;
  return result;
};
